import { render, staticRenderFns } from "./CountdownPopupBbl.vue?vue&type=template&id=12f5a2d3&scoped=true&"
import script from "./CountdownPopupBbl.vue?vue&type=script&lang=js&"
export * from "./CountdownPopupBbl.vue?vue&type=script&lang=js&"
import style0 from "./CountdownPopupBbl.vue?vue&type=style&index=0&id=12f5a2d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f5a2d3",
  null
  
)

export default component.exports